import script from "./VideoVuetable.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoVuetable.vue?vue&type=script&setup=true&lang=js"

import "./VideoVuetable.vue?vue&type=style&index=0&id=a0c6654a&lang=scss"

const __exports__ = script;

export default __exports__